import { getActiveLanguageCode } from 'services/i18nService';


const pageSEOConfigs = [
  {
    page: 1,
    h1: 'directory.directory.heading.h1.live.sex',
    link: {
      en: 'live-sex',
      fr: 'sexe-live',
      it: 'sesso-live',
      es: 'webcam-sexo',
      de: 'live-sex',
      nl: 'live-sex',
      sv: 'live-sex',
    },
    key: 'directory.directory.meta.title.live.sex',
    meta: 'directory.directory.meta.description.live.sex',
    bottomText: 'directory.directory.page.bottom.text.live.sex',
  },
  {
    page: 2,
    h1: 'directory.directory.heading.h1.sex.cams',
    link: {
      en: 'sex-cams',
      fr: 'cam-sexe',
      it: 'cam-sesso',
      es: 'sex-cams',
      'es-ES': 'sex-cams',
      de: 'sex-cams',
      nl: 'sex-cams',
      sv: 'sex-cams',
    },
    key: 'directory.directory.meta.title.sex.cams',
    meta: 'directory.directory.meta.description.sex.cams',
    bottomText: 'directory.directory.page.bottom.text.sex.cams',
  },
  {
    page: 3,
    h1: 'directory.directory.heading.h1.sex.chat',
    link: {
      en: 'sex-chat',
      fr: 'chat-sexe',
      it: 'chat-porno',
      es: 'chat-sexo',
      'es-ES': 'chat-sexo',
      de: 'sex-chat',
      nl: 'sex-chat',
      sv: 'sex-chat',
    },
    key: 'directory.directory.meta.title.sex.chat',
    meta: 'directory.directory.meta.description.sex.chat',
    bottomText: 'directory.directory.page.bottom.text.sex.chat',
  },
  {
    page: 4,
    h1: 'directory.directory.heading.h1.free.sex',
    link: {
      en: 'free-sex',
      fr: 'cam-gratuit',
      it: 'chat-gratis',
      es: 'chat-gratis',
      'es-ES': 'chat-gratis',
      de: 'sex-gratis',
      nl: 'gratis-sex',
      sv: 'gratis-sex',
    },
    key: 'directory.directory.meta.title.free.sex',
    meta: 'directory.directory.meta.description.free.sex',
    bottomText: 'directory.directory.page.bottom.text.free.sex',
  },
  {
    page: 5,
    h1: 'directory.directory.heading.h1.cam.chat',
    link: {
      en: 'cam-chat',
      fr: 'cam-chat',
      it: 'cam-chat',
      es: 'chat-cam',
      'es-ES': 'chat-cam',
      de: 'erotik-cam-chat',
      nl: 'cam-chat',
      sv: 'cam-chat',
    },
    key: 'directory.directory.meta.title.cam.chat',
    meta: 'directory.directory.meta.description.cam.chat',
    bottomText: 'directory.directory.page.bottom.text.cam.chat',
  },
  {
    page: 6,
    h1: 'directory.directory.heading.h1.video.chat',
    link: {
      en: 'sex-video-chat',
      fr: 'sexe-video-chat',
      it: 'videochat-sesso',
      es: 'video-chat',
      'es-ES': 'video-chat',
      de: 'sex-video-chat',
      nl: 'video-sex-chat',
      sv: 'webcam-shat',
    },
    key: 'directory.directory.meta.title.video.chat',
    meta: 'directory.directory.meta.description.video.chat',
    bottomText: 'directory.directory.page.bottom.text.video.chat',
  },
  {
    page: 7,
    h1: 'directory.directory.heading.h1.porn.chat',
    link: {
      en: 'porn-chat',
      fr: 'chat-porno',
      it: 'videochat-porno',
      es: 'chat-porno',
      'es-ES': 'chat-porno',
      de: 'porno-chat',
      nl: 'live-porno-chat',
      sv: 'porn-chatt',
    },
    key: 'directory.directory.meta.title.porn.chat',
    meta: 'directory.directory.meta.description.porn.chat',
    bottomText: 'directory.directory.page.bottom.text.porn.chat',
  },
  {
    page: 8,
    h1: 'directory.directory.heading.h1.xxx.live',
    link: {
      en: 'xxx-live',
      fr: 'cam-xxx-live',
      it: 'cam-xxx',
      es: 'webcam-xxx',
      'es-ES': 'webcam-xxx',
      de: 'xxx-live',
      nl: 'xxx-live',
      sv: 'xxx-live',
    },
    key: 'directory.directory.meta.title.xxx.live',
    meta: 'directory.directory.meta.description.xxx.live',
    bottomText: 'directory.directory.page.bottom.text.xxx.live',
  },
  {
    page: 9,
    h1: 'directory.directory.heading.h1.adult.cams',
    link: {
      en: 'adult-cams',
      fr: 'cam-x',
      it: 'cam-adulti',
      es: 'webcam-adultos',
      'es-ES': 'webcam-adultos',
      de: 'erwachsenen-cams',
      nl: 'webcam-sex',
      sv: 'vuxna-cams',
    },
    key: 'directory.directory.meta.title.adult.cams',
    meta: 'directory.directory.meta.description.adult.cams',
    bottomText: 'directory.directory.page.bottom.text.adult.cams',
  },
  {
    page: 10,
    h1: 'directory.directory.heading.h1.nude.cams',
    link: {
      en: 'nude-cams',
      fr: 'cam-nu',
      it: 'nude-cam',
      es: 'cam-chicas-desnudas',
      'es-ES': 'cam-chicas-desnudas',
      de: 'nude-cams',
      nl: 'nude-cams',
      sv: 'nude-cams',
    },
    key: 'directory.directory.meta.title.nude.cams',
    meta: 'directory.directory.meta.description.nude.cams',
    bottomText: 'directory.directory.page.bottom.text.nude.cams',
  },
  {
    page: 11,
    h1: 'directory.directory.heading.h1.amateur.cams',
    link: {
      en: 'amateur-cams',
      fr: 'webcam-amateur',
      it: 'webcam-amatoriali',
      es: 'cam-amateur',
      'es-ES': 'cam-amateur',
      de: 'amateur-cams',
      nl: 'amateur-cams',
      sv: 'amatör-porr',
    },
    key: 'directory.directory.meta.title.amateur.cams',
    meta: 'directory.directory.meta.description.amateur.cams',
    bottomText: 'directory.directory.page.bottom.text.amateur.cams',
  },
  {
    page: 12,
    h1: 'directory.directory.heading.h1.fuck.cams',
    link: {
      en: 'fuck-cams',
      fr: 'cam-porno',
      it: 'cam-scopate',
      es: 'webcam-follada',
      'es-ES': 'webcam-follada',
      de: 'fick-cams',
      nl: 'fuck-cams',
      sv: 'knulla-cam',
    },
    key: 'directory.directory.meta.title.fuck.cams',
    meta: 'directory.directory.meta.description.fuck.cams',
    bottomText: 'directory.directory.page.bottom.text.fuck.cams',
  },
];

export const getSEOConfig = (urlAlias) => {
  const activeLang = getActiveLanguageCode();

  const result = pageSEOConfigs.find((config) => {
    const urlAliases = config.link;

    const hasDirectMatch = urlAliases[activeLang] === urlAlias;
    if (hasDirectMatch) {
      return true;
    }

    const allAvailableLanguages = Object.keys(urlAliases);
    const anyLanguageMatch = allAvailableLanguages.find(
      (lang) => urlAliases[lang] === urlAlias
    );

    return Boolean(anyLanguageMatch);
  });

  return result;
};
